module.exports = __webpack_public_path__ + "img/1501594356.cfa5dab4.jpg";